<button type="button" class="btn btn-donate"
    (click)="modalDonate()"
    ngbTooltip="Apoya este ministerio." placement="top" container="body"
    *ngIf="isNotContentPPV">
    Donar
</button>

